export const LightboxSymbol = Symbol('Lightbox')
export const CurrentLightboxSymbol = Symbol('CurrentLightbox')
export const LightboxUtilsSymbol = Symbol('LightboxUtils')
export const LightboxesAPISymbol = Symbol('LightboxesAPI')
export const LightboxesResponseHandlerSymbol = Symbol('LightboxesResponseHandler')

export const name = 'lightbox' as const
